/**
 * @global
 * @namespace
 */
class MoveComment
{
	/** @type {PopupHelper} */
	_popupHelper = null;

	constructor()
	{
		let thisObj = this;
		this._popupHelper = new PopupHelper("#move-comment-popup", {
			popupOKCallback: thisObj._submitRequest.bind(thisObj),
			resetFieldsCallback: thisObj._resetFields.bind(thisObj),
		});
	}

	open(endpoint, commentText)
	{
		this._popupHelper.open(endpoint, commentText);
	}

	_resetFields(endpoint, commentText)
	{
		$(`${this._popupHelper.containerSelector} .comment-content`).html(commentText);
		$(`${this._popupHelper.containerSelector} [name="select-idea"]`).prop("checked", false);
	}

	_submitRequest(endpoint, commentText)
	{
		const $checkedIdea = $(`${this._popupHelper.containerSelector} input:checked[name="select-idea"]`);
		const ideaId = $checkedIdea.val();
		
		const popupHelper = this._popupHelper;
		const data = {
			toIdeaId: ideaId
		};
		popupHelper.showLoading();

		dataAction.callClientPostEndpoint(
			endpoint,
			data,
			function (response)
			{
				popupHelper.close();
				showSuccessPopup(response, mvvm.reset);
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}
}